export enum DemandAccountType {
  'PrivateDemand' = 'PrivateDemand',
  'BusinessDemand' = 'BusinessDemand'
}
